import React from 'react'
import Banner from '../components/Banner/Banner'


const BannerScreen = () => {
  return (
   <Banner/>
  )
}

export default BannerScreen